import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import Utils from '../../../middleware/Utils'
import { ERROR_MESSAGES } from '../../../components/common/GlobalMassssage'
import { AuthContext, LoaderContext } from '../../../Context/ContextFunctions'
import { GetDVRModel } from '../../../services/DVR/DVRApi'
import { AddUpdateLead } from '../../../services/Lead/LeadApi'
import SuccessModal from '../../../components/common/SuccessModal'
import { AddUpdateRoleType, GetRoleTypeModel } from '../../../services/UserRole/AddUpdateRoleApi'

const AddNewRoleModal = ({ show, onHide, modelRequestData, setIsAddUpdateActionDone }) => {
    const { authDetails } = useContext(AuthContext); // Get Login details
    const { setLoader } = useContext(LoaderContext);
    const [UserTypeList, setUserTypeList] = useState(Utils?.userTypeList)
    const [error, setError] = useState(false)
    const [actionMassage, setActionMassage] = useState('')
    const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
    const [roleObj, setRoleObj] = useState({
        userTypeID: null, roleName: null
    })

    useEffect(() => {
        if (modelRequestData?.Action !== null) {
            GetRoleModalData(modelRequestData?.roleTypeID)
        } else {
            setRoleObj((prev) => ({ ...prev, roleTypeID: modelRequestData?.roleTypeID }))
        }

    }, [])

    const GetRoleModalData = async (id) => {
        setLoader(true);
        // debugger;
        try {
            const response = await GetRoleTypeModel(id);
            if (response?.data?.statusCode === 200) {
                setLoader(false);

                const ModelData = response.data.responseData?.data || []; // Assuming the data is an array and we need the first item
                setRoleObj((prev) => ({
                    ...prev,
                    roleTypeID: ModelData?.roleTypeID,
                    userTypeID: ModelData?.userTypeID,
                    roleName: ModelData?.roleTypeName
                }))
            } else {
                setLoader(false);

                console.error(
                    "Error fetching data: ",
                    response?.data?.data?.statusCode
                );
            }
        } catch (error) {
            setLoader(false);

            console.error("Error", error);
        }
    };

    const handleSubmit = () => {
        let isValid = true
        if (roleObj?.userTypeID === null ||
            roleObj?.userTypeID === undefined ||
            roleObj?.userTypeID === "" || roleObj?.roleName === null ||
            roleObj?.roleName === undefined ||
            roleObj?.roleName === "") {
            setError(true)
            isValid = false
        }
        const apiParam = {
            userKeyID: authDetails?.userKeyID,
            roleTypeID: roleObj?.roleTypeID,
            userTypeID: roleObj?.userTypeID,
            roleTypeName: roleObj?.roleName
        }
        if (isValid) {
            AddUpdateRoleData(apiParam)

        }
    }

    const AddUpdateRoleData = async (apiParam) => {
        console.log('apiParam', apiParam)
        setLoader(true);
        try {
            const response = await AddUpdateRoleType(apiParam);
            if (response.data?.statusCode === 200) {
                // alert('Success');
                setLoader(false);

                setIsAddUpdateActionDone(true);

                if (modelRequestData.Action === null) {
                    setActionMassage("Role Added Successfully"); // set massage for success popup
                } else {
                    setActionMassage("Role Updated Successfully");
                }


                // setShowLeadUpdateModal(false); // close addUpdate modal
                setShowSuccessPopupModal(true); // open success popup modal
                setInitialData();
            } else {
                setLoader(false);

                console.error("Bad request");
            }
        } catch (error) {
            setLoader(false);

            console.log(error);
        }
    };

    const AddUpdateUserRole = () => {
        alert('Success')
        closeAll()
    }
    const handleUserRoleChangeChange = (value) => {
        setRoleObj((prevObj) => ({
            ...prevObj,
            userTypeID: value.value,
        }));
    };

    const setInitialData = () => {
        setRoleObj((prev) => ({ ...prev, userTypeID: null, roleName: null }))
        setError(false)
    }
    const closeAll = () => {
        setInitialData()
        onHide()
    }
    return (
        <>
            <div
                className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 "
                aria-hidden={!show}
            >
                <div className="bg-white rounded-lg shadow-lg w-6/12 max-w-4xl mx-auto flex flex-col mt-10 ">
                    <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
                        <h2 className="text-lg font-bold text-gray-700">
                            {modelRequestData.Action === null ? "Add Role" : "Update Role"}
                        </h2>
                        <button
                            className="text-gray-500 hover:text-gray-800"
                            onClick={closeAll}
                            aria-label="Close"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div
                        className="container mx-auto p-5 overflow-y-auto flex-grow"
                        style={{ maxHeight: "60vh" }}
                    >
                        <div className="grid grid-cols-1 sm:grid-cols-1  gap-2">

                            {/* User role Selector  */}
                            <div className="mb-4">
                                <div className="flex items-center">
                                    <label
                                        htmlFor="userType"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        User Type
                                        <span className="text-red-500">*</span>
                                    </label>

                                </div>
                                <Select
                                    options={UserTypeList}
                                    value={UserTypeList.filter(
                                        (val) => val.value === roleObj?.userTypeID
                                    )}
                                    onChange={handleUserRoleChangeChange}
                                    // isDisabled={modelRequestData?.Action === "update"}
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                />
                                {error &&
                                    (roleObj?.userTypeID === null ||
                                        roleObj?.userTypeID === undefined ||
                                        roleObj?.userTypeID === "") && (
                                        <span className="text-red-500 text-sm">
                                            {ERROR_MESSAGES}
                                        </span>
                                    )}
                            </div>
                            {/* New role name  */}
                            <div className="mb-4">
                                <label
                                    htmlFor="contactPersonName"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Role Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="bg-white-50 border border-gray-300 text-gray-700 text-sm rounded-lg focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 block w-full p-2.5"
                                    id="contactPersonName"
                                    placeholder="Enter Role Name"
                                    value={roleObj?.roleName || ""}
                                    onChange={(e) => {
                                        let updatedValue = e.target.value.replace(
                                            /[^a-zA-Z\s]/g,
                                            ""
                                        ); // Allows only characters and spaces

                                        if (updatedValue.startsWith(" ")) {
                                            updatedValue = updatedValue.trimStart(); // Remove leading space
                                        }

                                        setRoleObj((obj) => ({
                                            ...obj,
                                            roleName: updatedValue,
                                        }));
                                    }}
                                />
                                {error &&
                                    (roleObj?.roleName === null ||
                                        roleObj?.roleName === undefined ||
                                        roleObj?.roleName === "") && (
                                        <span className="text-red-500 text-sm">
                                            {ERROR_MESSAGES}
                                        </span>
                                    )}
                            </div>
                        </div>
                    </div>
                    {/* Modal Footer */}
                    <div className="flex justify-center gap-4 p-4 border-t sticky bottom-0 bg-white z-25">
                        <button
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                            onClick={onHide}
                        >
                            Close
                        </button>
                        <button
                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                            onClick={() => {
                                handleSubmit();
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>

            </div>
            {showSuccessPopupModal && (
                <SuccessModal
                    isOpen={showSuccessPopupModal}
                    onClose={() => closeAll()}
                    actionMassage={actionMassage}
                />
            )}
        </>
    )
}

export default AddNewRoleModal
